export default {
      id: "LWS-7px-usage",
      viewBox: "0 0 60 7",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#LWS-7px",
      toString: function () {
        return this.url;
      }
    }